<template>
<div>
    <header v-if="$route.params.id != 'me'">
        <a href="#" @click.prevent="goBack" class="back"></a>
        <h1>Benachrichtigungen</h1>
    </header>
    <section>
        <notifications :notifications="notifications" />
        <infinite-loading @infinite="scrollHandler">
            <span slot="no-results">
                Hier ist noch nichts los :(<br>
                Füge Freunde hinzu, um das zu ändern!
            </span>
            <span slot="no-more">
                Es gibt keine weiteren Benachrichtigungen.
            </span>
        </infinite-loading>
    </section>
</div>
</template>

<script>
import base from 'base.vue'
import notifications from 'components/notifications.vue'
import infiniteLoading from 'vue-infinite-loading'
import _ from 'underscore'

export default {
    mixins: [ base ],
    components: { notifications, infiniteLoading },
    data () {
        return {
            notifications: [ ]
        }
    },
    methods: {
        fetchData () {
            const that = this

            return this.$api.get('notifications/all')
            .then(response => {
                that.notifications = response.data
            })
        },
        scrollHandler ($state) {
            // Note that the first batch of notifications is loaded by `fetchData()`

            // No notifications found - empty list
            if (this.notifications.length == 0) {
                $state.complete()
                return
            }

            const that = this
            this.$api.get('notifications/all', {
                after: _.last(this.notifications).id
            })
            .then(response => {
                that.notifications = that.notifications.concat(response.data)

                // Call `loaded()` at least once if the list is not empty
                // (`fetchData()` did load one or more notifications)
                $state.loaded()

                // No further notifications found - end of list
                if (response.data.length == 0) {
                    $state.complete()
                }
            })
        },
    }
}
</script>



// WEBPACK FOOTER //
// notification-archive.vue?d84544f8